
export const buildApiUrl = (params) => {
  let url = "";
  if (params && Object.keys(params).length > 0) {
    Object.keys(params).forEach((key, i) => {
      const prefix = i === 0 ? `?` : `&`;
      url += `${prefix}${key}=${params[key]}`;
    });
  }
  return url;
};

export const getDiscount = (price, discount) => {
  return (price - price / 100 * discount).toLocaleString('vi-VN')
}

export const setPrice = (price) => {
  return price?.toLocaleString('vi-VN')
}

export const actionScrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
};

export const get_day_of_time = (d1, d2) => {
  let ms1 = d1.getTime();
  let ms2 = d2.getTime();
  return Math.ceil((ms2 - ms1) / (24 * 60 * 60 * 1000));
};


export const baseURLApi = "https://travel-with-me-api-v1.onrender.com/api/v1"
// export const baseURLApi = "http://localhost:5000/api/v1"
export const appURL = "https://travel-with-me-page.netlify.app/"
// export const appURL = "http://localhost:3000/"
